import { Component, HostListener, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActionApiService } from 'src/app/Services/action-api/action-api.service';
import {
	NEWOPTANONCONSENT,
	OPTANONCONSENT,
	SplunkAnalyticsService,
} from 'src/app/Services/splunk-analytics/splunk-analytics-service';
import { LayoutService } from '../../../../Services/layout/layout.service';
import { ConfigService } from 'src/app/Services/config.service';
import { StoreService } from 'src/app/Services/store';

window['OptanonWrapper'] = function () {
	if (window['getCcpaCookie']) {
		window['getCcpaCookie']();
	}
};
@Component({
	selector: 'footer-dr',
	templateUrl: './footer-dr.component.html',
	styleUrls: ['./footer-dr.component.scss'],
})
export class FooterDrComponent implements OnInit {
	model: any;
	currentYear: number;
	quoteNumber: string;
	ccpaLinkHerf: string;
	lastCookieValue: string;
	currentCookieValue: string;
	oneTrustHasLoaded: boolean;

	constructor(
		private LayoutService: LayoutService,
		private cookieService: CookieService,
		private actionApiService: ActionApiService,
		private splunkAnalyticsService: SplunkAnalyticsService,
		private configService: ConfigService,
		private storeService: StoreService
	) {
		this.ccpaLinkHerf = this.configService.getConfig().ccpaLink;
		window['getCcpaCookie'] = this.getCcpaCookie.bind(this);
	}

	async ngOnInit() {
		const globalAttributes = this.storeService.getGlobalAttributes();

		if (!this.oneTrustHasLoaded && globalAttributes && !globalAttributes['ccpaFlag']) {
			const scriptEle = document.createElement('script');
			scriptEle.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
			scriptEle.setAttribute('type', 'text/javascript');
			scriptEle.setAttribute('charset', 'UTF-8');
			scriptEle.setAttribute('data-domain-script', this.configService.getConfig().oneTrust);
			document.head.appendChild(scriptEle);
			this.oneTrustHasLoaded = true;
		}

		if (globalAttributes && globalAttributes['ccpaFlag']) {
			const optanonConsentCookieValue = this.cookieService.get(NEWOPTANONCONSENT);

			this.postOptanonConsentAction(optanonConsentCookieValue);
		}

		this.LayoutService.staticLayout.subscribe((data) => {
			if (data && data.data && data.data.metadata && data.data.metadata.page && data.data.metadata.page.state) {
				this.model = data.data;
				this.quoteNumber = this.model.globalAttributes && this.model.globalAttributes.PartnerQuoteNumber;
				this.currentYear = new Date().getFullYear();
			}
		});

		this.splunkAnalyticsService.publish('SysEvent', 'OptanonConsent');
	}

	ccpaClick(event?: KeyboardEvent) {
		if (!event || event.keyCode == 13 || event.keyCode == 32) {
			window['OneTrust'] && window['OneTrust'].ToggleInfoDisplay();
		}
	}

	getCcpaCookie() {
		const optanonConsentVal = this.cookieService.get(OPTANONCONSENT);
		const requestBody: request = {
			data: { OptanonConsent: optanonConsentVal },
			info: {
				action: 'OptanonConsent',
				conditions: '',
				elementSrc: '',
				stage: '',
				notRenderPage: false,
			},
		};

		this.actionApiService.invokeAction(requestBody);
		sessionStorage.setItem(OPTANONCONSENT, JSON.stringify(optanonConsentVal));

		this.splunkAnalyticsService.publish('SysEvent', 'OptanonConsent');
	}

	@HostListener('window:blur', ['$event']) c(event) {
		this.onBlur(event);
	}
	onBlur(event: FocusEvent): void {
		this.lastCookieValue = this.cookieService.get(NEWOPTANONCONSENT);
	}

	@HostListener('window:focus', ['$event']) b(event) {
		this.onFocus(event);
	}
	onFocus(event: FocusEvent): void {
		const globalAttributes = this.storeService.getGlobalAttributes();
		if (globalAttributes && globalAttributes['ccpaFlag']) {
			this.currentCookieValue = this.cookieService.get(NEWOPTANONCONSENT);

			if (this.lastCookieValue != this.currentCookieValue) {
				this.lastCookieValue = this.currentCookieValue;

				this.postOptanonConsentAction(this.currentCookieValue);
			}
		}
	}

	private postOptanonConsentAction(optanonConsentCookieValue: string) {
		const requestBody: request = {
			data: {
				OptanonConsent:
					optanonConsentCookieValue.endsWith('1') || optanonConsentCookieValue == '' ? 'C0004%3A1' : 'C0004%3A0',
			},
			info: {
				action: 'OptanonConsent',
				conditions: '',
				elementSrc: '',
				stage: '',
				notRenderPage: false,
			},
		};

		this.actionApiService.invokeAction(requestBody);
	}

	getGtmTitle(title: string) {
		return title.trim().replace(/ /g, '_');
	}
}
